import type { DistanceUnit } from './types/api';

export const DEFAULT_DISTANCE_UNIT: DistanceUnit = 'miles';

const MILES_PER_KILOMETER = 0.621371192237334;

export function distanceFromKilometers(
  distanceKm: number,
  unit: DistanceUnit = DEFAULT_DISTANCE_UNIT,
): number {
  return unit === 'miles' ? distanceKm * MILES_PER_KILOMETER : distanceKm;
}

export function formatDistance(
  distanceKm: number,
  unit: DistanceUnit = DEFAULT_DISTANCE_UNIT,
  fractionDigits = 1,
): string {
  const value = distanceFromKilometers(distanceKm, unit).toFixed(fractionDigits);
  return `${value} ${unit === 'miles' ? 'mi' : 'km'}`;
}

export function formatDistanceInWords(
  distanceKm: number,
  unit: DistanceUnit = DEFAULT_DISTANCE_UNIT,
  fractionDigits = 1,
): string {
  const value = distanceFromKilometers(distanceKm, unit).toFixed(fractionDigits);
  return `${value} ${unit === 'miles' ? 'miles' : 'km'}`;
}

export function formatCalculatedDistanceText(
  text: string,
  distanceKm: number,
  unit: DistanceUnit = DEFAULT_DISTANCE_UNIT,
): string {
  const formatted = formatDistanceInWords(distanceKm, unit);
  const historicalKilometers = `${distanceKm.toFixed(1)} km`;
  const defaultMiles = `${distanceFromKilometers(distanceKm, 'miles').toFixed(1)} miles`;
  return text.replaceAll(historicalKilometers, formatted).replaceAll(defaultMiles, formatted);
}
